import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/xapiItinerary'

export const xapiItineraryService = {
    getItinerary
}

function getItinerary( reservationNumber ) {
    return utilHelper.doRequestHandleResponse(
        `${relativeUrl}/search?reservationNumber=${reservationNumber}`,
        'POST',
        { showAlert:false }
    )
}